// ============================================================================
// ADHKAR DATA - UNIFIED VERSION
// ============================================================================

import type { AdhkarItem, AdhkarSection } from '../core/types';

// إعادة تصدير الأنواع للتوافق
export type { AdhkarItem, AdhkarSection } from '../core/types';
import { Utils } from '../core/utils';

// تم دمج العناصر القرآنية (البسملة والاستعاذة) مباشرة في البيانات

/**
 * أذكار الصباح
 */
export const morningAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "قُلْ هُوَ اللَّهُ أَحَدٌ، اللَّهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُنْ لَهُ كُفُوًا أَحَدٌ",
      en: "Say, He is Allah, [who is] One, Allah, the Eternal Refuge. He neither begets nor is born, nor is there to Him any equivalent."
    },
    repeat: { ar: "من قالها حين يصبح وحين يمسى كفته من كل شيء (الاخلاص و المعوذتين)", en: "3 times" },
    count: 3,
    type: 'quran',
    reference: { ar: "سورة الإخلاص", en: "Surah Al-Ikhlas" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'morning',
    priority: 1,
    tags: ['quran', 'morning', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ، مِنْ شَرِّ مَا خَلَقَ، وَمِنْ شَرِّ غَاسِقٍ إِذَا وَقَبَ، وَمِنْ شَرِّ النَّفَّاثَاتِ فِي الْعُقَدِ، وَمِنْ شَرِّ حَاسِدٍ إِذَا حَسَدَ",
      en: "Say, I seek refuge in the Lord of daybreak, from the evil of what He has created, and from the evil of darkness when it settles, and from the evil of the blowers in knots, and from the evil of an envier when he envies."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'quran',
    reference: { ar: "سورة الفلق", en: "Surah Al-Falaq" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'morning',
    priority: 2,
    tags: ['quran', 'morning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "قُلْ أَعُوذُ بِرَبِّ النَّاسِ، مَلِكِ النَّاسِ، إِلَهِ النَّاسِ، مِنْ شَرِّ الْوَسْوَاسِ الْخَنَّاسِ، الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ، مِنَ الْجِنَّةِ وَالنَّاسِ",
      en: "Say, I seek refuge in the Lord of mankind, the Sovereign of mankind, the God of mankind, from the evil of the whisperer who withdraws, who whispers in the breasts of mankind, of jinn and men."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'quran',
    reference: { ar: "سورة الناس", en: "Surah An-Nas" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'morning',
    priority: 3,
    tags: ['quran', 'morning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُ لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ، لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ، لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ، مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ، يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ، وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ، وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ، وَلَا يَئُودُهُ حِفْظُهُمَا، وَهُوَ الْعَلِيُّ الْعَظِيمُ",
      en: "Allah! There is no deity except Him, the Ever-Living, the Sustainer of [all] existence. Neither drowsiness overtakes Him nor sleep. To Him belongs whatever is in the heavens and whatever is on the earth. Who is it that can intercede with Him except by His permission? He knows what is before them and what will be after them, and they encompass not a thing of His knowledge except for what He wills. His Kursi extends over the heavens and the earth, and their preservation tires Him not. And He is the Most High, the Most Great."
    },
    repeat: { ar: "من قالها حين يصبح أجير من الجن حتى يمسى ومن قالها حين يمسى أجير من الجن حتى يصبح", en: "Whoever recites this in the morning will be protected from jinn until evening, and whoever recites it in the evening will be protected until morning" },
    count: 1,
    type: 'quran',
    reference: { ar: "آية الكرسي - البقرة: 255", en: "Ayat al-Kursi - Al-Baqarah 2:255" },
    istiatha: { ar: "أَعُوذُ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيمِ", en: "I seek refuge in Allah from the accursed Satan" },
    category: 'morning',
    priority: 4,
    tags: ['quran', 'morning', 'protection', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: { 
      ar: "أَصْبَحْنَا وَأَصْبَحَ الْمُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ، لاَ إِلَهَ إِلاَّ اللهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ، رَبِّ أَسْأَلُكَ خَيْرَ مَا فِي هَذَا الْيَوْمِ وَخَيْرَ مَا بَعْدَهُ، وَأَعُوذُ بِكَ مِنْ شَرِّ مَا فِي هَذَا الْيَوْمِ وَشَرِّ مَا بَعْدَهُ، رَبِّ أَعُوذُ بِكَ مِنَ الْكَسَلِ وَسُوءِ الْكِبَرِ، رَبِّ أَعُوذُ بِكَ مِنْ عَذَابٍ فِي النَّارِ وَعَذَابٍ فِي الْقَبْرِ", 
      en: "We have reached the morning and at this very time all sovereignty belongs to Allah. All praise is for Allah. None has the right to be worshipped except Allah, alone, without any partner, to Him belongs all sovereignty and praise and He is over all things omnipotent. My Lord, I ask You for the good of this day and the good of what follows it and I take refuge with You from the evil of this day and the evil of what follows it. My Lord, I take refuge with You from laziness and senility. My Lord, I take refuge with You from torment in the Fire and punishment in the grave" 
    },
    repeat: { ar: "من قالها حين يصبح أجير من الجن حتى يمسى ومن قالها حين يمسى أجير من الجن حتى يصبح", en: "Whoever recites this in the morning will be protected from jinn until evening, and whoever recites it in the evening will be protected until morning" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الصباح", en: "Morning Supplication" },
    category: 'morning',
    priority: 6,
    tags: ['dua', 'morning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَنْتَ رَبِّي لاَ إِلَهَ إِلاَّ أَنْتَ، خَلَقْتَنِي وَأَنَا عَبْدُكَ، وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ، أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ، أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ، وَأَبُوءُ لَكَ بِذَنْبِي فَاغْفِرْ لِي، فَإِنَّهُ لاَ يَغْفِرُ الذُّنُوبَ إِلاَّ أَنْتَ",
      en: "O Allah, You are my Lord, none has the right to be worshipped except You, You created me and I am Your servant and I abide to Your covenant and promise as best I can, I take refuge in You from the evil of which I have committed. I acknowledge Your favor upon me and I acknowledge my sin, so forgive me, for verily none can forgive sin except You."
    },
    repeat: { ar: "من قالها موقنا بها حين يمسى ومات من ليلته دخل الجنة وكذلك حين يصبح ", en: "Once - Master of Seeking Forgiveness" },
    count: 1,
    type: 'dua',
    reference: { ar: "سيد الاستغفار", en: "Master of Seeking Forgiveness - Sahih Bukhari" },
    category: 'morning',
    priority: 7,
    tags: ['dua', 'morning', 'forgiveness', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "رَضِيتُ بِاللَّهِ رَبًّا، وَبِالإِسْلَامِ دِينًا، وَبِمُحَمَّدٍ صلى الله عليه وسلم رَسُولاً",
      en: "I am pleased with Allah as a Lord, and Islam as a religion, and Muhammad (peace be upon him) as a Messenger."
    },
    repeat: { ar: "من قالها حين يصبح وحين يمسى كان حفا على الله ان يرضيه يوم القيامة", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'morning',
    priority: 9,
    tags: ['dua', 'morning', 'contentment', 'faith'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَصْبَحْتُ أُشْهِدُكَ، وَأُشْهِدُ حَمَلَةَ عَرْشِكَ، وَمَلَائِكَتَكَ، وَجَمِيعَ خَلْقِكَ، أَنَّكَ أَنْتَ اللَّهُ لَا إِلَهَ إِلَّا أَنْتَ وَحْدَكَ لَا شَرِيكَ لَكَ، وَأَنَّ مُحَمَّدًا عَبْدُكَ وَرَسُولُكَ",
      en: "O Allah, I have reached the morning and call on You, the bearers of Your throne, Your angels, and all of Your creation to witness that You are Allah, none has the right to be worshipped except You, alone, without partner and that Muhammad is Your servant and Messenger."
    },
    repeat: { ar: "من قالها اعتقه الله من النار", en: "4 times" },
    count: 4,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'morning',
    priority: 12,
    tags: ['dua', 'morning', 'testimony', 'important'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ مَا أَصْبَحَ بِي مِنْ نِعْمَةٍ أَوْ بِأَحَدٍ مِنْ خَلْقِكَ، فَمِنْكَ وَحْدَكَ لَا شَرِيكَ لَكَ، فَلَكَ الْحَمْدُ وَلَكَ الشُّكْرُ",
      en: "O Allah, what blessing I or any of Your creation have risen upon, is from You alone, without partner, so for You is all praise and unto You all thanks."
    },
    repeat: { ar: "من قالها حين يصبح أدى شكر يومه", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'morning',
    priority: 13,
    tags: ['dua', 'morning', 'gratitude', 'blessing'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "حَسْبِيَ اللَّهُ لاَ إِلَهَ إِلاَّ هُوَ عَلَيْهِ تَوَكَّلْتُ وَهُوَ رَبُّ الْعَرْشِ الْعَظِيمِ",
      en: "Allah is sufficient for me, none has the right to be worshipped except Him, upon Him I rely and He is Lord of the exalted throne."
    },
    repeat: { ar: "من قالها كفاه الله ما أهمه من أمر الدنيا والأخرة", en: "7 times" },
    count: 7,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'morning',
    priority: 16,
    tags: ['dua', 'morning', 'reliance', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "بِسْمِ اللَّهِ الَّذِي لاَ يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الأَرْضِ وَلاَ فِي السَّمَاءِ وَهُوَ السَّمِيعُ الْعَلِيمُ",
      en: "In the name of Allah with whose name nothing is harmed on earth nor in the heavens, and He is The All-Hearing, The All-Knowing."
    },
    repeat: { ar: "لم يضره من الله شيء", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'morning',
    priority: 8,
    tags: ['dua', 'morning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ بِكَ أَصْبَحْنَا وَبِكَ أَمْسَيْنَا، وَبِكَ نَحْيَا وَبِكَ نَمُوتُ، وَإِلَيْكَ النُّشُورُ",
      en: "O Allah, by You we have reached the morning and by You we reach the evening, by You we live and by You we die, and unto You is the resurrection."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'morning',
    priority: 18,
    tags: ['dua', 'morning', 'life', 'resurrection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ، عَدَدَ خَلْقِهِ، وَرِضَا نَفْسِهِ، وَزِنَةَ عَرْشِهِ، وَمِدَادَ كَلِمَاتِهِ",
      en: "Glory and praise to Allah, equal to the number of His creation, His pleasure, the weight of His throne, and the ink of His words."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'morning',
    priority: 15,
    tags: ['dua', 'morning', 'glorification', 'special'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ عَافِنِي فِي بَدَنِي، اللَّهُمَّ عَافِنِي فِي سَمْعِي، اللَّهُمَّ عَافِنِي فِي بَصَرِي، لَا إِلَهَ إِلَّا أَنْتَ",
      en: "O Allah, grant me health in my body. O Allah, grant me health in my hearing. O Allah, grant me health in my sight. None has the right to be worshipped except You."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'morning',
    priority: 25,
    tags: ['dua', 'morning', 'health', 'body'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَافِيَةَ فِي الدُّنْيَا وَالآخِرَةِ، اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي دِينِي وَدُنْيَايَ وَأَهْلِي وَمَالِي، اللَّهُمَّ اسْتُرْ عَوْرَاتِي وَآمِنْ رَوْعَاتِي، اللَّهُمَّ احْفَظْنِي مِنْ بَيْنِ يَدَيَّ وَمِنْ خَلْفِي وَعَنْ يَمِينِي وَعَنْ شِمَالِي وَمِنْ فَوْقِي، وَأَعُوذُ بِعَظَمَتِكَ أَنْ أُغْتَالَ مِنْ تَحْتِي",
      en: "O Allah, I ask You for well-being in this world and the next. O Allah, I ask You for forgiveness and well-being in my religion, my worldly life, my family and my wealth. O Allah, veil my weaknesses and set at ease my dismay. O Allah, preserve me from the front and from behind and on my right and on my left and from above, and I take refuge with You lest I be swallowed up by the earth."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود وابن ماجه", en: "Hadith - Abu Dawud and Ibn Majah" },
    category: 'morning',
    priority: 11,
    tags: ['dua', 'morning', 'protection', 'wellbeing'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "يَا حَيُّ يَا قَيُّومُ بِرَحْمَتِكَ أَسْتَغِيثُ، أَصْلِحْ لِي شَأْنِي كُلَّهُ، وَلَا تَكِلْنِي إِلَى نَفْسِي طَرْفَةَ عَيْنٍ",
      en: "O Ever-Living, O Self-Sustaining, by Your mercy I seek help. Set right for me all my affairs and do not leave me to myself even for the blink of an eye."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - الحاكم", en: "Hadith - Al-Hakim" },
    category: 'morning',
    priority: 22,
    tags: ['dua', 'morning', 'help', 'reliance'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ خَيْرَ هَذَا الْيَوْمِ: فَتْحَهُ وَنَصْرَهُ وَنُورَهُ وَبَرَكَتَهُ وَهُدَاهُ، وَأَعُوذُ بِكَ مِنْ شَرِّ مَا فِيهِ وَشَرِّ مَا بَعْدَهُ",
      en: "O Allah, I ask You for the good of this day: its conquest, victory, light, blessing and guidance. I take refuge in You from the evil in it and the evil that comes after it."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'morning',
    priority: 24,
    tags: ['dua', 'morning', 'day', 'victory'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ فَاطِرَ السَّمَاوَاتِ وَالْأَرْضِ، عَالِمَ الْغَيْبِ وَالشَّهَادَةِ، رَبَّ كُلِّ شَيْءٍ وَمَلِيكَهُ، أَشْهَدُ أَنْ لَا إِلَهَ إِلَّا أَنْتَ، أَعُوذُ بِكَ مِنْ شَرِّ نَفْسِي، وَمِنْ شَرِّ الشَّيْطَانِ وَشِرْكِهِ أَوْ أَجُرَّهُ إِلَى مُسْلِمٍ",
      en: "O Allah, Creator of the heavens and the earth, Knower of the unseen and the seen, Lord and Sovereign of everything, I bear witness that none has the right to be worshipped except You. I take refuge in You from the evil of my soul and from the evil and shirk of the devil."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'morning',
    priority: 19,
    tags: ['dua', 'morning', 'testimony', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنَ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنَ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ وَقَهْرِ الرِّجَالِ",
      en: "O Allah, I take refuge in You from anxiety and sorrow, weakness and laziness, miserliness and cowardice, the burden of debts and from being over powered by men."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الكرب - صحيح البخاري", en: "Supplication for distress - Sahih Bukhari" },
    category: 'morning',
    priority: 17,
    tags: ['dua', 'morning', 'anxiety', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ",
      en: "I seek refuge in the perfect words of Allah from the evil of what He has created."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'morning',
    priority: 9,
    tags: ['dua', 'morning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
      en: "None has the right to be worshipped except Allah, alone, without any partner. To Him belongs all sovereignty and praise and He is over all things omnipotent."
    },
    repeat: { ar: "مئة مرة", en: "100 times" },
    count: 100,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'morning',
    priority: 10,
    tags: ['dua', 'morning', 'tahleel'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْمًا نَافِعًا، وَرِزْقًا طَيِّبًا، وَعَمَلًا مُتَقَبَّلًا",
      en: "O Allah, I ask You for beneficial knowledge, good provision and acceptable deeds."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - ابن ماجه", en: "Hadith - Ibn Majah" },
    category: 'morning',
    priority: 14,
    tags: ['dua', 'morning', 'knowledge', 'provision'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ وَرَحْمَتِكَ، فَإِنَّهُ لَا يَمْلِكُهَا إِلَّا أَنْتَ",
      en: "O Allah, I ask You from Your bounty and mercy, for indeed none possesses them except You."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - الطبراني", en: "Hadith - At-Tabarani" },
    category: 'morning',
    priority: 20,
    tags: ['dua', 'morning', 'bounty', 'mercy'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَعِذْنِي مِنْ عَذَابِكَ يَوْمَ تَبْعَثُ عِبَادَكَ",
      en: "O Allah, protect me from Your punishment on the day You resurrect Your servants."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'morning',
    priority: 21,
    tags: ['dua', 'morning', 'protection', 'afterlife'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
 
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْهُدَى وَالتُّقَى وَالْعَفَافَ وَالْغِنَى",
      en: "O Allah, I ask You for guidance, piety, chastity and independence from others."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'morning',
    priority: 23,
    tags: ['dua', 'morning', 'guidance', 'piety'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  
];

/**
 * أذكار المساء
 */
export const eveningAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "قُلْ هُوَ اللَّهُ أَحَدٌ، اللَّهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُنْ لَهُ كُفُوًا أَحَدٌ",
      en: "Say, He is Allah, [who is] One, Allah, the Eternal Refuge. He neither begets nor is born, nor is there to Him any equivalent."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'quran',
    reference: { ar: "سورة الإخلاص", en: "Surah Al-Ikhlas" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'morning',
    priority: 1,
    tags: ['quran', 'morning', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ، مِنْ شَرِّ مَا خَلَقَ، وَمِنْ شَرِّ غَاسِقٍ إِذَا وَقَبَ، وَمِنْ شَرِّ النَّفَّاثَاتِ فِي الْعُقَدِ، وَمِنْ شَرِّ حَاسِدٍ إِذَا حَسَدَ",
      en: "Say, I seek refuge in the Lord of daybreak, from the evil of what He has created, and from the evil of darkness when it settles, and from the evil of the blowers in knots, and from the evil of an envier when he envies."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'quran',
    reference: { ar: "سورة الفلق", en: "Surah Al-Falaq" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'morning',
    priority: 2,
    tags: ['quran', 'morning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "قُلْ أَعُوذُ بِرَبِّ النَّاسِ، مَلِكِ النَّاسِ، إِلَهِ النَّاسِ، مِنْ شَرِّ الْوَسْوَاسِ الْخَنَّاسِ، الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ، مِنَ الْجِنَّةِ وَالنَّاسِ",
      en: "Say, I seek refuge in the Lord of mankind, the Sovereign of mankind, the God of mankind, from the evil of the whisperer who withdraws, who whispers in the breasts of mankind, of jinn and men."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'quran',
    reference: { ar: "سورة الناس", en: "Surah An-Nas" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'morning',
    priority: 3,
    tags: ['quran', 'morning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُ لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ، لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ، لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ، مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ، يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ، وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ، وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ، وَلَا يَئُودُهُ حِفْظُهُمَا، وَهُوَ الْعَلِيُّ الْعَظِيمُ",
      en: "Allah! There is no deity except Him, the Ever-Living, the Sustainer of [all] existence. Neither drowsiness overtakes Him nor sleep. To Him belongs whatever is in the heavens and whatever is on the earth. Who is it that can intercede with Him except by His permission? He knows what is before them and what will be after them, and they encompass not a thing of His knowledge except for what He wills. His Kursi extends over the heavens and the earth, and their preservation tires Him not. And He is the Most High, the Most Great."
    },
    repeat: { ar: "من قالها حين يصبح أجير من الجن حتى يمسى ومن قالها حين يمسى أجير من الجن حتى يصبح", en: "Whoever recites this in the morning will be protected from jinn until evening, and whoever recites it in the evening will be protected until morning" },
    count: 1,
    type: 'quran',
    reference: { ar: "آية الكرسي - البقرة: 255", en: "Ayat al-Kursi - Al-Baqarah 2:255" },
    istiatha: { ar: "أَعُوذُ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيمِ", en: "I seek refuge in Allah from the accursed Satan" },
    category: 'morning',
    priority: 4,
    tags: ['quran', 'morning', 'protection', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ ۚ كُلٌّ آمَنَ بِاللَّهِ وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ ۚ وَقَالُوا سَمِعْنَا وَأَطَعْنَا ۖ غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ (285) لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا وُسْعَهَا ۚ لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ ۗ رَبَّنَا لَا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ أَخْطَأْنَا ۚ رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَّذِينَ مِنْ قَبْلِنَا ۚ رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِ ۖ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا ۚ أَنْتَ مَوْلَانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ (286)",
      en: "The Messenger has believed in what was revealed to him from his Lord, and [so have] the believers. All of them have believed in Allah and His angels and His books and His messengers, [saying], 'We make no distinction between any of His messengers.' And they say, 'We hear and we obey. [We seek] Your forgiveness, our Lord, and to You is the [final] destination.' (285) Allah does not charge a soul except [with that within] its capacity. It will have [the consequence of] what [good] it has gained, and it will bear [the consequence of] what [evil] it has earned. 'Our Lord, do not impose blame upon us if we forget or make a mistake. Our Lord, and lay not upon us a burden like that which You laid upon those before us. Our Lord, and burden us not with that which we have no ability to bear. And pardon us; and forgive us; and have mercy upon us. You are our protector, so give us victory over the disbelieving people.' (286)"
    },
    repeat: { ar: "من قرأ ايتين من أخر سورة البقرة في ليلة كفتاه", en: "" },
    count: 1,
    type: 'quran',
    reference: { ar: "آخر آيتين من سورة البقرة - 285-286", en: "Last two verses of Al-Baqarah - 2:285-286" },
    istiatha: { ar: "أَعُوذُ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيمِ", en: "I seek refuge in Allah from the accursed Satan" },
    category: 'morning',
    priority: 5,
    tags: ['quran', 'morning', 'protection', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "أَمْسَيْنَا وَأَمْسَى الْمُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ، لاَ إِلَهَ إِلاَّ اللهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ، رَبِّ أَسْأَلُكَ خَيْرَ مَا فِي هَذِهِ اللَّيْلَةِ وَخَيْرَ مَا بَعْدَهَا، وَأَعُوذُ بِكَ مِنْ شَرِّ مَا فِي هَذِهِ اللَّيْلَةِ وَشَرِّ مَا بَعْدَهَا، رَبِّ أَعُوذُ بِكَ مِنَ الْكَسَلِ وَسُوءِ الْكِبَرِ، رَبِّ أَعُوذُ بِكَ مِنْ عَذَابٍ فِي النَّارِ وَعَذَابٍ فِي الْقَبْرِ",
      en: "We have reached the evening and at this very time all sovereignty belongs to Allah. All praise is for Allah. None has the right to be worshipped except Allah, alone, without any partner, to Him belongs all sovereignty and praise and He is over all things omnipotent. My Lord, I ask You for the good of this night and the good of what follows it and I take refuge with You from the evil of this night and the evil of what follows it. My Lord, I take refuge with You from laziness and senility. My Lord, I take refuge with You from torment in the Fire and punishment in the grave"
    },
    repeat: { ar: "من قالها حين يمسى أجير من الجن حتى يصبح", en: "Whoever recites this in the evening will be protected from jinn until morning" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء المساء", en: "Evening Supplication" },
    category: 'evening',
    priority: 1,
    tags: ['dua', 'evening', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَنْتَ رَبِّي لاَ إِلَهَ إِلاَّ أَنْتَ، خَلَقْتَنِي وَأَنَا عَبْدُكَ، وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ، أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ، أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ، وَأَبُوءُ لَكَ بِذَنْبِي فَاغْفِرْ لِي، فَإِنَّهُ لاَ يَغْفِرُ الذُّنُوبَ إِلاَّ أَنْتَ",
      en: "O Allah, You are my Lord, none has the right to be worshipped except You, You created me and I am Your servant and I abide to Your covenant and promise as best I can, I take refuge in You from the evil of which I have committed. I acknowledge Your favor upon me and I acknowledge my sin, so forgive me, for verily none can forgive sin except You."
    },
    repeat: { ar: "مرة واحدة - سيد الاستغفار", en: "Once - Master of Seeking Forgiveness" },
    count: 1,
    type: 'dua',
    reference: { ar: "سيد الاستغفار - صحيح البخاري", en: "Master of Seeking Forgiveness - Sahih Bukhari" },
    category: 'evening',
    priority: 2,
    tags: ['dua', 'evening', 'forgiveness', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "بِسْمِ اللَّهِ الَّذِي لاَ يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الأَرْضِ وَلاَ فِي السَّمَاءِ وَهُوَ السَّمِيعُ الْعَلِيمُ",
      en: "In the name of Allah with whose name nothing is harmed on earth nor in the heavens, and He is The All-Hearing, The All-Knowing."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'evening',
    priority: 3,
    tags: ['dua', 'evening', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ",
      en: "I seek refuge in the perfect words of Allah from the evil of what He has created."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'evening',
    priority: 4,
    tags: ['dua', 'evening', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَافِيَةَ فِي الدُّنْيَا وَالآخِرَةِ، اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي دِينِي وَدُنْيَايَ وَأَهْلِي وَمَالِي، اللَّهُمَّ اسْتُرْ عَوْرَاتِي وَآمِنْ رَوْعَاتِي، اللَّهُمَّ احْفَظْنِي مِنْ بَيْنِ يَدَيَّ وَمِنْ خَلْفِي وَعَنْ يَمِينِي وَعَنْ شِمَالِي وَمِنْ فَوْقِي، وَأَعُوذُ بِعَظَمَتِكَ أَنْ أُغْتَالَ مِنْ تَحْتِي",
      en: "O Allah, I ask You for well-being in this world and the next. O Allah, I ask You for forgiveness and well-being in my religion, my worldly life, my family and my wealth. O Allah, veil my weaknesses and set at ease my dismay. O Allah, preserve me from the front and from behind and on my right and on my left and from above, and I take refuge with You lest I be swallowed up by the earth."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود وابن ماجه", en: "Hadith - Abu Dawud and Ibn Majah" },
    category: 'evening',
    priority: 5,
    tags: ['dua', 'evening', 'protection', 'wellbeing'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ عَالِمَ الْغَيْبِ وَالشَّهَادَةِ فَاطِرَ السَّمَاوَاتِ وَالأَرْضِ، رَبَّ كُلِّ شَيْءٍ وَمَلِيكَهُ، أَشْهَدُ أَنْ لاَ إِلَهَ إِلاَّ أَنْتَ، أَعُوذُ بِكَ مِنْ شَرِّ نَفْسِي وَمِنْ شَرِّ الشَّيْطَانِ وَشِرْكِهِ، وَأَنْ أَقْتَرِفَ عَلَى نَفْسِي سُوءًا أَوْ أَجُرَّهُ إِلَى مُسْلِمٍ",
      en: "O Allah, Knower of the unseen and the seen, Creator of the heavens and the earth, Lord and Sovereign of all things, I bear witness that none has the right to be worshipped except You. I take refuge in You from the evil of my soul and from the evil and shirk of the devil, and from committing wrong against my soul or bringing such upon another Muslim."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'evening',
    priority: 6,
    tags: ['dua', 'evening', 'protection', 'testimony'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَمْسَيْتُ أُشْهِدُكَ، وَأُشْهِدُ حَمَلَةَ عَرْشِكَ، وَمَلَائِكَتَكَ، وَجَمِيعَ خَلْقِكَ، أَنَّكَ أَنْتَ اللَّهُ لَا إِلَهَ إِلَّا أَنْتَ وَحْدَكَ لَا شَرِيكَ لَكَ، وَأَنَّ مُحَمَّدًا عَبْدُكَ وَرَسُولُكَ",
      en: "O Allah, I have reached the evening and call on You, the bearers of Your throne, Your angels, and all of Your creation to witness that You are Allah, none has the right to be worshipped except You, alone, without partner and that Muhammad is Your servant and Messenger."
    },
    repeat: { ar: "أربع مرات", en: "4 times" },
    count: 4,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'evening',
    priority: 7,
    tags: ['dua', 'evening', 'testimony', 'important'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ مَا أَمْسَى بِي مِنْ نِعْمَةٍ أَوْ بِأَحَدٍ مِنْ خَلْقِكَ، فَمِنْكَ وَحْدَكَ لَا شَرِيكَ لَكَ، فَلَكَ الْحَمْدُ وَلَكَ الشُّكْرُ",
      en: "O Allah, what blessing I or any of Your creation have reached the evening upon, is from You alone, without partner, so for You is all praise and unto You all thanks."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'evening',
    priority: 8,
    tags: ['dua', 'evening', 'gratitude', 'blessing'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "رَضِيتُ بِاللَّهِ رَبًّا، وَبِالإِسْلَامِ دِينًا، وَبِمُحَمَّدٍ صلى الله عليه وسلم رَسُولاً",
      en: "I am pleased with Allah as a Lord, and Islam as a religion, and Muhammad (peace be upon him) as a Messenger."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'evening',
    priority: 9,
    tags: ['dua', 'evening', 'contentment', 'faith'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ بِكَ أَمْسَيْنَا، وَبِكَ أَصْبَحْنَا، وَبِكَ نَحْيَا، وَبِكَ نَمُوتُ، وَإِلَيْكَ الْمَصِيرُ",
      en: "O Allah, by You we have reached the evening, by You we have reached the morning, by You we live and by You we die, and unto You is the final return."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'evening',
    priority: 10,
    tags: ['dua', 'evening', 'reliance', 'return'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "حَسْبِيَ اللَّهُ لاَ إِلَهَ إِلاَّ هُوَ عَلَيْهِ تَوَكَّلْتُ وَهُوَ رَبُّ الْعَرْشِ الْعَظِيمِ",
      en: "Allah is sufficient for me, none has the right to be worshipped except Him, upon Him I rely and He is Lord of the exalted throne."
    },
    repeat: { ar: "سبع مرات", en: "7 times" },
    count: 7,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'evening',
    priority: 11,
    tags: ['dua', 'evening', 'reliance', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ فَاطِرَ السَّمَاوَاتِ وَالْأَرْضِ، عَالِمَ الْغَيْبِ وَالشَّهَادَةِ، رَبَّ كُلِّ شَيْءٍ وَمَلِيكَهُ، أَشْهَدُ أَنْ لَا إِلَهَ إِلَّا أَنْتَ، أَعُوذُ بِكَ مِنْ شَرِّ نَفْسِي، وَمِنْ شَرِّ الشَّيْطَانِ وَشِرْكِهِ",
      en: "O Allah, Creator of the heavens and the earth, Knower of the unseen and the seen, Lord and Sovereign of everything, I bear witness that none has the right to be worshipped except You. I take refuge in You from the evil of my soul and from the evil and shirk of the devil."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'evening',
    priority: 12,
    tags: ['dua', 'evening', 'testimony', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ خَيْرَ هَذِهِ اللَّيْلَةِ: فَتْحَهَا وَنَصْرَهَا وَنُورَهَا وَبَرَكَتَهَا وَهُدَاهَا، وَأَعُوذُ بِكَ مِنْ شَرِّ مَا فِيهَا وَشَرِّ مَا بَعْدَهَا",
      en: "O Allah, I ask You for the good of this night: its conquest, victory, light, blessing and guidance. I take refuge in You from the evil in it and the evil that comes after it."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'evening',
    priority: 13,
    tags: ['dua', 'evening', 'night', 'victory'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ عَافِنِي فِي بَدَنِي، اللَّهُمَّ عَافِنِي فِي سَمْعِي، اللَّهُمَّ عَافِنِي فِي بَصَرِي، لَا إِلَهَ إِلَّا أَنْتَ",
      en: "O Allah, grant me health in my body. O Allah, grant me health in my hearing. O Allah, grant me health in my sight. None has the right to be worshipped except You."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'evening',
    priority: 14,
    tags: ['dua', 'evening', 'health', 'body'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "يَا حَيُّ يَا قَيُّومُ بِرَحْمَتِكَ أَسْتَغِيثُ، أَصْلِحْ لِي شَأْنِي كُلَّهُ، وَلَا تَكِلْنِي إِلَى نَفْسِي طَرْفَةَ عَيْنٍ",
      en: "O Ever-Living, O Self-Sustaining, by Your mercy I seek help. Set right for me all my affairs and do not leave me to myself even for the blink of an eye."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - الحاكم", en: "Hadith - Al-Hakim" },
    category: 'evening',
    priority: 15,
    tags: ['dua', 'evening', 'help', 'reliance'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْهُدَى وَالتُّقَى وَالْعَفَافَ وَالْغِنَى",
      en: "O Allah, I ask You for guidance, piety, chastity and independence from others."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'evening',
    priority: 16,
    tags: ['dua', 'evening', 'guidance', 'piety'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * أذكار بعد الصلاة
 */
export const afterPrayerAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "أَسْتَغْفِرُ اللَّهَ، أَسْتَغْفِرُ اللَّهَ، أَسْتَغْفِرُ اللَّهَ",
      en: "I seek forgiveness from Allah, I seek forgiveness from Allah, I seek forgiveness from Allah"
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "استغفار بعد الصلاة", en: "Seeking forgiveness after prayer" },
    category: 'after-salah',
    priority: 1,
    tags: ['dua', 'after-prayer', 'forgiveness'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَنْتَ السَّلاَمُ وَمِنْكَ السَّلاَمُ، تَبَارَكْتَ يَا ذَا الْجَلاَلِ وَالإِكْرَامِ",
      en: "O Allah, You are As-Salaam (The Source of Peace) and from You comes peace, blessed are You, O Possessor of majesty and honor."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'after-salah',
    priority: 2,
    tags: ['dua', 'after-prayer', 'praise'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "سُبْحَانَ اللَّهِ",
      en: "Glory is to Allah"
    },
    repeat: { ar: "ثلاث وثلاثون مرة", en: "33 times" },
    count: 33,
    type: 'dua',
    reference: { ar: "التسبيح بعد الصلاة - البخاري ومسلم", en: "Glorification after prayer - Bukhari and Muslim" },
    category: 'after-salah',
    priority: 3,
    tags: ['dua', 'after-prayer', 'tasbeeh', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "الْحَمْدُ لِلَّهِ",
      en: "All praise is due to Allah"
    },
    repeat: { ar: "ثلاث وثلاثون مرة", en: "33 times" },
    count: 33,
    type: 'dua',
    reference: { ar: "التحميد بعد الصلاة - البخاري ومسلم", en: "Praise after prayer - Bukhari and Muslim" },
    category: 'after-salah',
    priority: 4,
    tags: ['dua', 'after-prayer', 'tahmeed', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُ أَكْبَرُ",
      en: "Allah is the Greatest"
    },
    repeat: { ar: "أربع وثلاثون مرة", en: "34 times" },
    count: 34,
    type: 'dua',
    reference: { ar: "التكبير بعد الصلاة - البخاري ومسلم", en: "Takbeer after prayer - Bukhari and Muslim" },
    category: 'after-salah',
    priority: 5,
    tags: ['dua', 'after-prayer', 'takbeer', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
      en: "None has the right to be worshipped except Allah, alone, without any partner. To Him belongs all sovereignty and praise and He is over all things omnipotent."
    },
    repeat: { ar: "مرة واحدة لتتم المئة", en: "Once to complete 100" },
    count: 1,
    type: 'dua',
    reference: { ar: "التهليل بعد الصلاة - البخاري ومسلم", en: "Tahleel after prayer - Bukhari and Muslim" },
    category: 'after-salah',
    priority: 6,
    tags: ['dua', 'after-prayer', 'tahleel', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ، اللَّهُمَّ لاَ مَانِعَ لِمَا أَعْطَيْتَ، وَلاَ مُعْطِيَ لِمَا مَنَعْتَ، وَلاَ يَنْفَعُ ذَا الْجَدِّ مِنْكَ الْجَدُّ",
      en: "None has the right to be worshipped except Allah, alone, without any partner. To Him belongs all sovereignty and praise and He is over all things omnipotent. O Allah, none can prevent what You have willed to bestow and none can bestow what You have willed to prevent, and no wealth or majesty can benefit the wealthy, for all wealth and majesty belong to You."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء شامل بعد الصلاة - البخاري ومسلم", en: "Comprehensive supplication after prayer - Bukhari and Muslim" },
    category: 'after-salah',
    priority: 7,
    tags: ['dua', 'after-prayer', 'comprehensive'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * أذكار النوم
 */
export const sleepAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "بِاسْمِكَ رَبِّي وَضَعْتُ جَنْبِي، وَبِكَ أَرْفَعُهُ، فَإِنْ أَمْسَكْتَ نَفْسِي فَارْحَمْهَا، وَإِنْ أَرْسَلْتَهَا فَاحْفَظْهَا بِمَا تَحْفَظُ بِهِ عِبَادَكَ الصَّالِحِينَ",
      en: "In Your name, my Lord, I lie down and in Your name I rise, so if You should take my soul then have mercy upon it, and if You should return my soul then protect it in the manner You do so with Your righteous servants"
    },
    repeat: { ar: "مرة واحدة", en: "1 time" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء النوم", en: "Sleep supplication" },
    category: 'sleep',
    priority: 1,
    tags: ['dua', 'sleep', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْلَمْتُ نَفْسِي إِلَيْكَ، وَوَجَّهْتُ وَجْهِي إِلَيْكَ، وَفَوَّضْتُ أَمْرِي إِلَيْكَ، وَأَلْجَأْتُ ظَهْرِي إِلَيْكَ، رَغْبَةً وَرَهْبَةً إِلَيْكَ، لاَ مَلْجَأَ وَلاَ مَنْجَا مِنْكَ إِلاَّ إِلَيْكَ، اللَّهُمَّ آمَنْتُ بِكِتَابِكَ الَّذِي أَنْزَلْتَ، وَبِنَبِيِّكَ الَّذِي أَرْسَلْتَ",
      en: "O Allah, I surrender my soul unto You, and I entrust my face unto You, and I turn my affairs over to You, and I rely upon You for blessings and protection, with hope and fear of You. There is no refuge and no safety from You except with You. I believe in the Book You have revealed and in the Prophet You have sent."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء النوم - صحيح البخاري", en: "Sleep supplication - Sahih Bukhari" },
    category: 'sleep',
    priority: 2,
    tags: ['dua', 'sleep', 'surrender', 'faith'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ رَبَّ السَّمَاوَاتِ وَرَبَّ الأَرْضِ وَرَبَّ الْعَرْشِ الْعَظِيمِ، رَبَّنَا وَرَبَّ كُلِّ شَيْءٍ، فَالِقَ الْحَبِّ وَالنَّوَى، وَمُنْزِلَ التَّوْرَاةِ وَالإِنْجِيلِ وَالْفُرْقَانِ، أَعُوذُ بِكَ مِنْ شَرِّ كُلِّ شَيْءٍ أَنْتَ آخِذٌ بِنَاصِيَتِهِ، اللَّهُمَّ أَنْتَ الأَوَّلُ فَلَيْسَ قَبْلَكَ شَيْءٌ، وَأَنْتَ الآخِرُ فَلَيْسَ بَعْدَكَ شَيْءٌ، وَأَنْتَ الظَّاهِرُ فَلَيْسَ فَوْقَكَ شَيْءٌ، وَأَنْتَ الْبَاطِنُ فَلَيْسَ دُونَكَ شَيْءٌ، اقْضِ عَنَّا الدَّيْنَ وَأَغْنِنَا مِنَ الْفَقْرِ",
      en: "O Allah, Lord of the heavens and the earth and Lord of the Mighty Throne, our Lord and Lord of all things, Splitter of the seed and the date stone, Revealer of the Torah and the Gospel and the Furqan, I take refuge in You from the evil of all things You shall seize by the forelock. O Allah, You are the First so there is nothing before You, and You are the Last so there is nothing after You, and You are the Most High so there is nothing above You, and You are the Most Near so there is nothing closer than You. Settle our debt for us and spare us from poverty."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء النوم الشامل - صحيح مسلم", en: "Comprehensive sleep supplication - Sahih Muslim" },
    category: 'sleep',
    priority: 3,
    tags: ['dua', 'sleep', 'comprehensive', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "قُلْ يَا أَيُّهَا الْكَافِرُونَ، لَا أَعْبُدُ مَا تَعْبُدُونَ، وَلَا أَنتُمْ عَابِدُونَ مَا أَعْبُدُ، وَلَا أَنَا عَابِدٌ مَّا عَبَدتُّمْ، وَلَا أَنتُمْ عَابِدُونَ مَا أَعْبُدُ، لَكُمْ دِينُكُمْ وَلِيَ دِينِ",
      en: "Say: O disbelievers! I do not worship that which you worship, nor do you worship that which I worship. And I shall not worship that which you worship. Nor will you worship that which I worship. To you your religion, and to me mine."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'quran',
    reference: { ar: "سورة الكافرون", en: "Surah Al-Kafiroon" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'sleep',
    priority: 4,
    tags: ['quran', 'sleep', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "الْحَمْدُ لِلَّهِ الَّذِي أَطْعَمَنَا وَسَقَانَا، وَكَفَانَا، وَآوَانَا، فَكَمْ مِمَّنْ لَا كَافِيَ لَهُ وَلَا مُؤْوِيَ",
      en: "All praise is for Allah, who fed us and gave us drink, and who is sufficient for us and has sheltered us, for how many have none to suffice them or shelter them."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الشكر عند النوم - صحيح مسلم", en: "Gratitude supplication at bedtime - Sahih Muslim" },
    category: 'sleep',
    priority: 5,
    tags: ['dua', 'sleep', 'gratitude'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا",
      en: "In Your name, O Allah, I die and I live."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح البخاري", en: "Hadith - Sahih Bukhari" },
    category: 'sleep',
    priority: 6,
    tags: ['dua', 'sleep', 'life', 'death'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ قِنِي عَذَابَكَ يَوْمَ تَبْعَثُ عِبَادَكَ",
      en: "O Allah, protect me from Your punishment on the day You resurrect Your servants."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'sleep',
    priority: 7,
    tags: ['dua', 'sleep', 'protection', 'afterlife'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "تَبَارَكَ الَّذِي بِيَدِهِ الْمُلْكُ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ، الَّذِي خَلَقَ الْمَوْتَ وَالْحَيَاةَ لِيَبْلُوَكُمْ أَيُّكُمْ أَحْسَنُ عَمَلًا وَهُوَ الْعَزِيزُ الْغَفُورُ...",
      en: "Blessed is He in whose hand is dominion, and He is over all things competent - [He] who created death and life to test you [as to] which of you is best in deed - and He is the Exalted in Might, the Forgiving..."
    },
    repeat: { ar: "قراءة سورة الملك", en: "Recitation of Surah Al-Mulk" },
    count: 1,
    type: 'quran',
    reference: { ar: "سورة الملك", en: "Surah Al-Mulk" },
    basmala: { ar: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ", en: "In the name of Allah, the Entirely Merciful, the Especially Merciful" },
    category: 'sleep',
    priority: 8,
    tags: ['quran', 'sleep', 'protection', 'complete-surah'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَسْلَمْتُ وَجْهِي إِلَيْكَ، وَفَوَّضْتُ أَمْرِي إِلَيْكَ، وَأَلْجَأْتُ ظَهْرِي إِلَيْكَ، رَغْبَةً وَرَهْبَةً إِلَيْكَ، لاَ مَلْجَأَ وَلاَ مَنْجَا مِنْكَ إِلاَّ إِلَيْكَ، آمَنْتُ بِكِتَابِكَ الَّذِي أَنزَلْتَ، وَبِنَبِيِّكَ الَّذِي أَرْسَلْتَ",
      en: "O Allah, I surrender my face (myself) to You, and leave my affair to You, and turn my back for protection to You, out of desire for You and fear of You. There is no fleeing from You, and there is no place of protection and safety except with You. I believe in Your Book which You have revealed and in Your Prophet whom You have sent."
    },
    repeat: { ar: "مرة واحدة", en: "Once" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'sleep',
    priority: 9,
    tags: ['dua', 'sleep', 'surrender', 'faith', 'comprehensive'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * أذكار متفرقة
 */
export const miscellaneousAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ، سُبْحَانَ اللَّهِ الْعَظِيمِ",
      en: "Glory be to Allah and His is the praise, glory be to Allah the Most Great"
    },
    repeat: { ar: "مائة مرة", en: "100 times" },
    count: 100,
    type: 'dua',
    reference: { ar: "تسبيح عام", en: "General Glorification" },
    category: 'miscellaneous',
    priority: 1,
    tags: ['dua', 'general', 'glorification'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "بِسْمِ اللَّهِ تَوَكَّلْتُ عَلَى اللَّهِ، وَلاَ حَوْلَ وَلاَ قُوَّةَ إِلاَّ بِاللَّهِ",
      en: "In the name of Allah, I place my trust in Allah, and there is no might nor power except with Allah."
    },
    repeat: { ar: "عند الخروج من المنزل", en: "When leaving home" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الخروج من المنزل - أبو داود والترمذي", en: "Supplication when leaving home - Abu Dawud and Tirmidhi" },
    category: 'miscellaneous',
    priority: 2,
    tags: ['dua', 'travel', 'protection', 'home'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "بِسْمِ اللَّهِ وَلَجْنَا، وَبِسْمِ اللَّهِ خَرَجْنَا، وَعَلَى اللَّهِ رَبِّنَا تَوَكَّلْنَا",
      en: "In the name of Allah we enter, in the name of Allah we leave, and upon Allah our Lord we place our trust."
    },
    repeat: { ar: "عند دخول المنزل", en: "When entering home" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء دخول المنزل - أبو داود", en: "Supplication when entering home - Abu Dawud" },
    category: 'miscellaneous',
    priority: 3,
    tags: ['dua', 'home', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ افْتَحْ لِي أَبْوَابَ رَحْمَتِكَ",
      en: "O Allah, open for me the doors of Your mercy."
    },
    repeat: { ar: "عند دخول المسجد", en: "When entering the mosque" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء دخول المسجد - صحيح مسلم", en: "Supplication when entering mosque - Sahih Muslim" },
    category: 'miscellaneous',
    priority: 4,
    tags: ['dua', 'mosque', 'mercy'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ وَرَحْمَتِكَ",
      en: "O Allah, I ask You from Your bounty and mercy."
    },
    repeat: { ar: "عند الخروج من المسجد", en: "When leaving the mosque" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الخروج من المسجد - صحيح مسلم", en: "Supplication when leaving mosque - Sahih Muslim" },
    category: 'miscellaneous',
    priority: 5,
    tags: ['dua', 'mosque', 'bounty'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "الْحَمْدُ لِلَّهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ",
      en: "All praise is for Allah who restored to us life after having taken it from us and unto Him is the resurrection."
    },
    repeat: { ar: "عند الاستيقاظ من النوم", en: "Upon waking up" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الاستيقاظ - صحيح البخاري", en: "Supplication upon waking - Sahih Bukhari" },
    category: 'miscellaneous',
    priority: 6,
    tags: ['dua', 'waking', 'gratitude'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "بِسْمِ اللَّهِ",
      en: "In the name of Allah"
    },
    repeat: { ar: "عند البدء بالطعام", en: "When starting to eat" },
    count: 1,
    type: 'dua',
    reference: { ar: "آداب الطعام - أبو داود والترمذي", en: "Etiquette of eating - Abu Dawud and Tirmidhi" },
    category: 'miscellaneous',
    priority: 7,
    tags: ['dua', 'food', 'etiquette'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "الْحَمْدُ لِلَّهِ الَّذِي أَطْعَمَنِي هَذَا وَرَزَقَنِيهِ مِنْ غَيْرِ حَوْلٍ مِنِّي وَلاَ قُوَّةٍ",
      en: "All praise is for Allah who fed me this and provided it for me without any might nor power from myself."
    },
    repeat: { ar: "عند الانتهاء من الطعام", en: "After finishing food" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء بعد الطعام - أبو داود والترمذي", en: "Supplication after eating - Abu Dawud and Tirmidhi" },
    category: 'miscellaneous',
    priority: 8,
    tags: ['dua', 'food', 'gratitude'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ بَارِكْ لَنَا فِيمَا رَزَقْتَنَا، وَقِنَا عَذَابَ النَّارِ",
      en: "O Allah, bless for us what You have provided us, and save us from the punishment of the Fire."
    },
    repeat: { ar: "دعاء بعد الطعام", en: "Supplication after food" },
    count: 1,
    type: 'dua',
    reference: { ar: "آداب الطعام - الترمذي", en: "Food etiquette - Tirmidhi" },
    category: 'miscellaneous',
    priority: 9,
    tags: ['dua', 'food', 'blessing'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "رَضِيتُ بِاللَّهِ رَبًّا، وَبِالإِسْلاَمِ دِينًا، وَبِمُحَمَّدٍ صلى الله عليه وسلم رَسُولاً",
      en: "I am pleased with Allah as a Lord, and Islam as a religion, and Muhammad (peace be upon him) as a Messenger."
    },
    repeat: { ar: "ثلاث مرات", en: "3 times" },
    count: 3,
    type: 'dua',
    reference: { ar: "دعاء الرضا - أبو داود", en: "Supplication of contentment - Abu Dawud" },
    category: 'miscellaneous',
    priority: 10,
    tags: ['dua', 'general', 'contentment', 'faith'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنَ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنَ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ وَقَهْرِ الرِّجَالِ",
      en: "O Allah, I take refuge in You from anxiety and sorrow, weakness and laziness, miserliness and cowardice, the burden of debts and from being over powered by men."
    },
    repeat: { ar: "عند الكرب والهم", en: "During distress and worry" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الكرب - صحيح البخاري", en: "Supplication for distress - Sahih Bukhari" },
    category: 'miscellaneous',
    priority: 11,
    tags: ['dua', 'distress', 'anxiety', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "لَا إِلَهَ إِلَّا اللَّهُ الْعَظِيمُ الْحَلِيمُ، لَا إِلَهَ إِلَّا اللَّهُ رَبُّ الْعَرْشِ الْعَظِيمِ، لَا إِلَهَ إِلَّا اللَّهُ رَبُّ السَّمَاوَاتِ وَرَبُّ الْأَرْضِ وَرَبُّ الْعَرْشِ الْكَرِيمِ",
      en: "None has the right to be worshipped except Allah, the Mighty, the Forbearing. None has the right to be worshipped except Allah, Lord of the Magnificent Throne. None has the right to be worshipped except Allah, Lord of the heavens, Lord of the Earth and Lord of the Noble Throne."
    },
    repeat: { ar: "عند الكرب الشديد", en: "During severe distress" },
    count: 1,
    type: 'dua',
    reference: { ar: "دعاء الكرب - البخاري ومسلم", en: "Supplication for distress - Bukhari and Muslim" },
    category: 'miscellaneous',
    priority: 12,
    tags: ['dua', 'severe-distress', 'relief', 'urgent'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ زَوَالِ نِعْمَتِكَ، وَتَحَوُّلِ عَافِيَتِكَ، وَفُجَاءَةِ نِقْمَتِكَ، وَجَمِيعِ سَخَطِكَ",
      en: "O Allah, I take refuge in You from the decline of Your favor, the passing of safety, the suddenness of Your vengeance and all of Your wrath."
    },
    repeat: { ar: "دعاء عام", en: "General supplication" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'miscellaneous',
    priority: 13,
    tags: ['dua', 'protection', 'favor', 'safety'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ اغْفِرْ لِي ذَنْبِي، وَخَطَئِي، وَجَهْلِي، وَمَا أَسْرَرْتُ، وَمَا أَعْلَنْتُ، وَمَا أَنْتَ أَعْلَمُ بِهِ مِنِّي",
      en: "O Allah, forgive me my sins, my errors, my ignorance, and what I have concealed and what I have done openly, and what You know better than I do."
    },
    repeat: { ar: "دعاء للاستغفار", en: "Supplication for forgiveness" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'miscellaneous',
    priority: 14,
    tags: ['dua', 'forgiveness', 'repentance', 'sins'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
      en: "Our Lord, give us good in this world and good in the next world, and save us from the punishment of the Fire."
    },
    repeat: { ar: "دعاء شامل", en: "Comprehensive supplication" },
    count: 1,
    type: 'quran',
    reference: { ar: "سورة البقرة آية 201", en: "Surah Al-Baqarah verse 201" },
    category: 'miscellaneous',
    priority: 15,
    tags: ['quran', 'comprehensive', 'dunya', 'akhirah'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَصْلِحْ لِي دِينِي الَّذِي هُوَ عِصْمَةُ أَمْرِي، وَأَصْلِحْ لِي دُنْيَايَ الَّتِي فِيهَا مَعَاشِي، وَأَصْلِحْ لِي آخِرَتِي الَّتِي فِيهَا مَعَادِي، وَاجْعَلِ الْحَيَاةَ زِيَادَةً لِي فِي كُلِّ خَيْرٍ، وَاجْعَلِ الْمَوْتَ رَاحَةً لِي مِنْ كُلِّ شَرٍّ",
      en: "O Allah, make my religion sound for me, whereby my affairs are protected. Make my worldly life sound for me, wherein is my livelihood. Make my afterlife sound for me, to which is my return. Make life for me an increase in every good, and make death for me a rest from every evil."
    },
    repeat: { ar: "دعاء شامل للحياة", en: "Comprehensive life supplication" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'miscellaneous',
    priority: 16,
    tags: ['dua', 'comprehensive', 'life', 'reform'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ عَلَى نَبِيِّنَا مُحَمَّدٍ",
      en: "O Allah, send prayers, peace and blessings upon our Prophet Muhammad."
    },
    repeat: { ar: "الصلاة على النبي", en: "Prayers upon the Prophet" },
    count: 1,
    type: 'dua',
    reference: { ar: "السنة النبوية", en: "Prophetic Tradition" },
    category: 'miscellaneous',
    priority: 17,
    tags: ['dua', 'prophet', 'salawat', 'blessing'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "لَا حَوْلَ وَلَا قُوَّةَ إِلَّا بِاللَّهِ الْعَلِيِّ الْعَظِيمِ",
      en: "There is no power and no strength except in Allah, the Most High, the Most Great."
    },
    repeat: { ar: "عند الحاجة للقوة", en: "When needing strength" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'miscellaneous',
    priority: 18,
    tags: ['dua', 'strength', 'power', 'reliance'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَعِنِّي عَلَى ذِكْرِكَ وَشُكْرِكَ وَحُسْنِ عِبَادَتِكَ",
      en: "O Allah, help me to remember You, to thank You, and to worship You in the best manner."
    },
    repeat: { ar: "دعاء للمعونة على العبادة", en: "Supplication for help in worship" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'miscellaneous',
    priority: 19,
    tags: ['dua', 'worship', 'remembrance', 'gratitude'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنَ الْخَيْرِ كُلِّهِ عَاجِلِهِ وَآجِلِهِ، مَا عَلِمْتُ مِنْهُ وَمَا لَمْ أَعْلَمْ، وَأَعُوذُ بِكَ مِنَ الشَّرِّ كُلِّهِ عَاجِلِهِ وَآجِلِهِ، مَا عَلِمْتُ مِنْهُ وَمَا لَمْ أَعْلَمْ",
      en: "O Allah, I ask You for all good, in this world and in the Hereafter, what I know of it and what I do not know. I seek refuge in You from all evil, in this world and in the Hereafter, what I know of it and what I do not know."
    },
    repeat: { ar: "دعاء جامع", en: "Comprehensive supplication" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - ابن ماجه", en: "Hadith - Ibn Majah" },
    category: 'miscellaneous',
    priority: 20,
    tags: ['dua', 'comprehensive', 'good', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * أذكار السفر
 */
export const travelAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُ أَكْبَرُ، اللَّهُ أَكْبَرُ، اللَّهُ أَكْبَرُ، سُبْحَانَ الَّذِي سَخَّرَ لَنَا هَذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ، وَإِنَّا إِلَى رَبِّنَا لَمُنْقَلِبُونَ",
      en: "Allah is Most Great, Allah is Most Great, Allah is Most Great. Glory to Him who has subjected this to us, and we could never have it (by our efforts). And to our Lord, surely, must we return!"
    },
    repeat: { ar: "عند بداية السفر", en: "At the beginning of travel" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'travel',
    priority: 1,
    tags: ['dua', 'travel', 'beginning', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنِّي أَسْأَلُكَ فِي سَفَرِي هَذَا الْبِرَّ وَالتَّقْوَى، وَمِنَ الْعَمَلِ مَا تَرْضَى، اللَّهُمَّ هَوِّنْ عَلَيْنَا سَفَرَنَا هَذَا وَاطْوِ عَنَّا بُعْدَهُ، اللَّهُمَّ أَنْتَ الصَّاحِبُ فِي السَّفَرِ، وَالْخَلِيفَةُ فِي الْأَهْلِ",
      en: "O Allah, I ask You for righteousness and piety in this journey of mine, and for deeds that are pleasing to You. O Allah, make this journey easy for us and make its distance short for us. O Allah, You are the Companion on the journey and the Guardian of the family."
    },
    repeat: { ar: "عند الخروج للسفر", en: "When departing for travel" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'travel',
    priority: 2,
    tags: ['dua', 'travel', 'departure', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ بَلِّغْنَا بَلَاغًا يُبَلِّغُ خَيْرًا، اللَّهُمَّ اقْلِبْنَا تَائِبِينَ آيِبِينَ عَابِدِينَ لِرَبِّنَا حَامِدِينَ",
      en: "O Allah, let us reach our destination in a manner that brings about good. O Allah, make us return repentant, obedient, worshipping our Lord, praising Him."
    },
    repeat: { ar: "دعاء السفر", en: "Travel supplication" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - الطبراني", en: "Hadith - At-Tabarani" },
    category: 'travel',
    priority: 3,
    tags: ['dua', 'travel', 'destination', 'return'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ إِنَّا نَسْأَلُكَ فِي سَفَرِنَا هَذَا الْبِرَّ وَالتَّقْوَى، وَمِنَ الْعَمَلِ مَا تَرْضَى",
      en: "O Allah, we ask You in this journey of ours for righteousness and piety, and for deeds that are pleasing to You."
    },
    repeat: { ar: "أثناء السفر", en: "During travel" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - الترمذي", en: "Hadith - At-Tirmidhi" },
    category: 'travel',
    priority: 4,
    tags: ['dua', 'travel', 'righteousness', 'piety'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "آيِبُونَ تَائِبُونَ عَابِدُونَ لِرَبِّنَا حَامِدُونَ",
      en: "Returning, repenting, worshipping, praising our Lord."
    },
    repeat: { ar: "عند العودة من السفر", en: "When returning from travel" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'travel',
    priority: 5,
    tags: ['dua', 'travel', 'return', 'repentance'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * أذكار الطقس والمطر
 */
export const weatherAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ صَيِّبًا نَافِعًا",
      en: "O Allah, (bring) beneficial rain."
    },
    repeat: { ar: "عند رؤية المطر", en: "When seeing rain" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح البخاري", en: "Hadith - Sahih Bukhari" },
    category: 'weather',
    priority: 1,
    tags: ['dua', 'rain', 'beneficial', 'weather'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "مُطِرْنَا بِفَضْلِ اللَّهِ وَرَحْمَتِهِ",
      en: "We have been given rain by the grace and mercy of Allah."
    },
    repeat: { ar: "بعد المطر", en: "After rain" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح البخاري", en: "Hadith - Sahih Bukhari" },
    category: 'weather',
    priority: 2,
    tags: ['dua', 'rain', 'gratitude', 'mercy'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ حَوَالَيْنَا وَلَا عَلَيْنَا، اللَّهُمَّ عَلَى الْآكَامِ وَالظِّرَابِ، وَبُطُونِ الْأَوْدِيَةِ، وَمَنَابِتِ الشَّجَرِ",
      en: "O Allah, (let it rain) around us and not upon us. O Allah, (let it rain) on the plateaus, hills, valleys and the roots of trees."
    },
    repeat: { ar: "عند شدة المطر", en: "During heavy rain" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح البخاري", en: "Hadith - Sahih Bukhari" },
    category: 'weather',
    priority: 3,
    tags: ['dua', 'rain', 'heavy', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ أَعُوذُ بِكَ مِنْ شَرِّ مَا فِيهَا، وَشَرِّ مَا أُرْسِلَتْ بِهِ",
      en: "O Allah, I take refuge in You from the evil that is in it and the evil it brings."
    },
    repeat: { ar: "عند رؤية الرعد والبرق", en: "When seeing thunder and lightning" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود والترمذي", en: "Hadith - Abu Dawud and Tirmidhi" },
    category: 'weather',
    priority: 4,
    tags: ['dua', 'thunder', 'lightning', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "سُبْحَانَ الَّذِي يُسَبِّحُ الرَّعْدُ بِحَمْدِهِ وَالْمَلَائِكَةُ مِنْ خِيفَتِهِ",
      en: "Glory be to Him whom thunder praises with His praise, and the angels out of fear of Him."
    },
    repeat: { ar: "عند سماع الرعد", en: "When hearing thunder" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - مالك", en: "Hadith - Malik" },
    category: 'weather',
    priority: 5,
    tags: ['dua', 'thunder', 'glorification', 'angels'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * أذكار المرض والشفاء
 */
export const illnessHealingAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "بِسْمِ اللَّهِ أَرْقِيكَ، مِنْ كُلِّ شَيْءٍ يُؤْذِيكَ، مِنْ شَرِّ كُلِّ نَفْسٍ أَوْ عَيْنِ حَاسِدٍ اللَّهُ يَشْفِيكَ، بِسْمِ اللَّهِ أَرْقِيكَ",
      en: "In the name of Allah I recite over you, from all things that harm you, from the evil of every soul or envious eye, may Allah heal you. In the name of Allah I recite over you."
    },
    repeat: { ar: "رقية شرعية", en: "Islamic healing" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح مسلم", en: "Hadith - Sahih Muslim" },
    category: 'illness-healing',
    priority: 1,
    tags: ['dua', 'healing', 'ruqyah', 'protection'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "أَذْهِبِ الْبَأْسَ رَبَّ النَّاسِ، اشْفِ وَأَنْتَ الشَّافِي، لَا شِفَاءَ إِلَّا شِفَاؤُكَ، شِفَاءً لَا يُغَادِرُ سَقَمًا",
      en: "Remove the hardship, Lord of mankind, and heal, for You are the Healer. There is no healing except Your healing, a healing that leaves no disease."
    },
    repeat: { ar: "دعاء للمريض", en: "Supplication for the sick" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'illness-healing',
    priority: 2,
    tags: ['dua', 'healing', 'sickness', 'Lord'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ اشْفِ عَبْدَكَ يَنْكَأُ لَكَ عَدُوًّا، أَوْ يَمْشِي لَكَ إِلَى صَلَاةٍ",
      en: "O Allah, heal Your servant who will strike an enemy for You, or walk to prayer for You."
    },
    repeat: { ar: "دعاء لشفاء المريض", en: "Supplication for healing the sick" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - أبو داود", en: "Hadith - Abu Dawud" },
    category: 'illness-healing',
    priority: 3,
    tags: ['dua', 'healing', 'servant', 'prayer'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "لَا بَأْسَ طَهُورٌ إِنْ شَاءَ اللَّهُ",
      en: "No harm, it is purification if Allah wills."
    },
    repeat: { ar: "عند عيادة المريض", en: "When visiting the sick" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - صحيح البخاري", en: "Hadith - Sahih Bukhari" },
    category: 'illness-healing',
    priority: 4,
    tags: ['dua', 'visiting', 'purification', 'comfort'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * أذكار الحج والعمرة
 */
export const hajjUmrahAzkar: AdhkarItem[] = [
  {
    id: Utils.generateId(),
    text: {
      ar: "لَبَّيْكَ اللَّهُمَّ لَبَّيْكَ، لَبَّيْكَ لَا شَرِيكَ لَكَ لَبَّيْكَ، إِنَّ الْحَمْدَ وَالنِّعْمَةَ لَكَ وَالْمُلْكَ، لَا شَرِيكَ لَكَ",
      en: "Here I am, O Allah, here I am. Here I am, You have no partner, here I am. Verily all praise, grace and sovereignty belong to You. You have no partner."
    },
    repeat: { ar: "التلبية", en: "Talbiyah" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'hajj-umrah',
    priority: 1,
    tags: ['dua', 'hajj', 'umrah', 'talbiyah', 'essential'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
      en: "Our Lord, give us good in this world and good in the next world, and save us from the punishment of the Fire."
    },
    repeat: { ar: "بين الركن والمقام", en: "Between the corner and Maqam" },
    count: 1,
    type: 'quran',
    reference: { ar: "سورة البقرة آية 201", en: "Surah Al-Baqarah verse 201" },
    category: 'hajj-umrah',
    priority: 2,
    tags: ['quran', 'hajj', 'umrah', 'dunya', 'akhirah'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "اللَّهُمَّ اغْفِرْ لِي ذَنْبِي وَخَطَئِي وَجَهْلِي",
      en: "O Allah, forgive my sins, my errors, and my ignorance."
    },
    repeat: { ar: "عند الطواف", en: "During Tawaf" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - البخاري ومسلم", en: "Hadith - Bukhari and Muslim" },
    category: 'hajj-umrah',
    priority: 3,
    tags: ['dua', 'hajj', 'umrah', 'tawaf', 'forgiveness'],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  {
    id: Utils.generateId(),
    text: {
      ar: "رَبِّ اغْفِرْ وَارْحَمْ وَأَنْتَ خَيْرُ الرَّاحِمِينَ",
      en: "My Lord, forgive and have mercy, for You are the best of those who show mercy."
    },
    repeat: { ar: "على جبل عرفة", en: "On Mount Arafat" },
    count: 1,
    type: 'dua',
    reference: { ar: "حديث شريف - الترمذي", en: "Hadith - At-Tirmidhi" },
    category: 'hajj-umrah',
    priority: 4,
    tags: ['dua', 'hajj', 'arafat', 'mercy', 'forgiveness'],
    createdAt: new Date(),
    updatedAt: new Date()
  }
];

/**
 * قائمة الأذكاري الكاملة
 */
export const adhkarList: AdhkarSection[] = [
  {
    id: 'morning',
    category: { ar: "أذكار الصباح", en: "Morning Azkar" },
    description: { ar: "أذكار وأدعية تقال في الصباح", en: "Azkar and supplications for the morning" },
    icon: '☀️',
    color: 'from-green-400 to-emerald-600',
    items: morningAzkar,
    priority: 1,
    isActive: true
  },
  {
    id: 'evening',
    category: { ar: "أذكار المساء", en: "Evening Azkar" },
    description: { ar: "أذكار وأدعية تقال في المساء", en: "Azkar and supplications for the evening" },
    icon: '🌙',
    color: 'from-indigo-400 to-blue-600',
    items: eveningAzkar,
    priority: 2,
    isActive: true
  },
  {
    id: 'after-salah',
    category: { ar: "أذكار بعد الصلاة", en: "After Salah Azkar" },
    description: { ar: "أذكار وأدعية بعد الصلاة المفروضة", en: "Azkar and supplications after obligatory prayers" },
    icon: '🕌',
    color: 'from-purple-400 to-pink-600',
    items: afterPrayerAzkar,
    priority: 3,
    isActive: true
  },
  {
    id: 'sleep',
    category: { ar: "أذكار النوم", en: "Sleep Azkar" },
    description: { ar: "أذكار النوم والاستيقاظ", en: "Sleep and wake up Azkar" },
    icon: '🛌',
    color: 'from-blue-400 to-indigo-600',
    items: sleepAzkar,
    priority: 4,
    isActive: true
  },
  {
    id: 'miscellaneous',
    category: { ar: "أذكار متفرقة", en: "Miscellaneous Azkar" },
    description: { ar: "أذكار متنوعة ومتفرقة", en: "Various and miscellaneous Azkar" },
    icon: '🌐',
    color: 'from-teal-400 to-cyan-600',
    items: miscellaneousAzkar,
    priority: 5,
    isActive: true
  },
  {
    id: 'travel',
    category: { ar: "أذكار السفر", en: "Travel Azkar" },
    description: { ar: "أذكار وأدعية السفر والرحلات", en: "Travel and journey azkar and supplications" },
    icon: '✈️',
    color: 'from-blue-400 to-cyan-600',
    items: travelAzkar,
    priority: 6,
    isActive: true
  },
  {
    id: 'weather',
    category: { ar: "أذكار الطقس والمطر", en: "Weather & Rain Azkar" },
    description: { ar: "أذكار المطر والرعد والطقس", en: "Rain, thunder and weather azkar" },
    icon: '🌧️',
    color: 'from-sky-400 to-blue-600',
    items: weatherAzkar,
    priority: 7,
    isActive: true
  },
  {
    id: 'illness-healing',
    category: { ar: "أذكار المرض والشفاء", en: "Illness & Healing Azkar" },
    description: { ar: "أذكار المرض والشفاء والرقية", en: "Sickness, healing and ruqyah azkar" },
    icon: '💊',
    color: 'from-green-400 to-teal-600',
    items: illnessHealingAzkar,
    priority: 8,
    isActive: true
  },
  {
    id: 'hajj-umrah',
    category: { ar: "أذكار الحج والعمرة", en: "Hajj & Umrah Azkar" },
    description: { ar: "أذكار الحج والعمرة والمناسك", en: "Hajj, Umrah and pilgrimage azkar" },
    icon: '🕋',
    color: 'from-amber-400 to-orange-600',
    items: hajjUmrahAzkar,
    priority: 9,
    isActive: true
  }
];

// البيانات متاحة للاستيراد من التصديرات أعلاه
